/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// Above global eslint rules disabled as GlideJS has no TS implementation
/**
 * Carousel Component
 * @module patterns/components/enquiry-contact
 */
// eslint-disable-next-line @typescript-eslint/ban-tslint-comment
/* tslint:disable:no-any */

// Dependencies

// import { markElementReady } from '@root/src/framework/scripts/helpers/element-ready';
// import { scrollIntoView } from '~/framework/utils/scroll';
import { type App } from '~/app';

export default (app: App) => {
	app.logger.debug('[Stockland FE] Initialise Stockland Enquiry Contact Component');

	const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

	app.afterMount
		.then(() =>
			setTimeout(() => {
				mountEnquireContact(listeners);
			}, 200)
		)
		.catch((error: ErrorOptions) => {
			throw new Error('[Stockland FE] Unable to register Stockland Enquiry Contact Carousel Component', error);
		});

	return () => {
		unMountEnquireContact(listeners);

		app.logger.debug('[DXA] Horizontal Enquiry Contact Component destroyed');
	};
};

function unMountEnquireContact(
	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
	for (const [element, event, listener] of listeners) {
		element.removeEventListener(event, listener);
	}
}

export function mountEnquireContact(
	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
	// const contactFormButtons = document.querySelectorAll<HTMLElement>(".enquiry-contact-button");

	// for (const button of contactFormButtons) {
	//     const contactFormParent= button.closest(".enquiry-contact-form");
	//     const contactForm = contactFormParent!.querySelector(".enquiry-contact-form-container");
	//     button.setAttribute('type', 'button')

	//     if (!button.dataset.hasListener) {
	//         button.addEventListener("click", () => {
	//             contactForm?.classList.remove("hidden");
	//             button.classList.add("hidden")

	//         });
	//         button.dataset.hasListener = 'true';
	//     }

	// }

	const phoneDetails = document.querySelectorAll<HTMLElement>('.phone-click');
	const emailDetails = document.querySelectorAll<HTMLElement>('.email-click');

	removeFormFieldFocus();
	for (const phoneDetail of phoneDetails) {
		const number = phoneDetail.querySelector<HTMLElement>('.phone');
		const numberView = phoneDetail.querySelector<HTMLElement>('.phone-view');
		if (!phoneDetail.dataset.hasListener) {
			phoneDetail.addEventListener('click', () => {
				if (number && numberView) {
					// Start transition to hide the view element
					numberView.classList.add('opacity-0');
					numberView.classList.add('pointer-events-none');

					// Ensure the number element is ready to be shown

					setTimeout(() => {
						number.classList.remove('hidden');
						// Fully display the number element after the transition
						numberView.classList.add('hidden');
						number.classList.remove('opacity-0');
					}, 300); // Match this duration with your transition duration
				}
			});
			phoneDetail.dataset.hasListener = 'true';
		}
	}

	for (const emailDetail of emailDetails) {
		const email = emailDetail.querySelector<HTMLElement>('.email');
		const emailView = emailDetail.querySelector<HTMLElement>('.email-view');
		if (!emailDetail.dataset.hasListener) {
			emailDetail.addEventListener('click', () => {
				if (email && emailView) {
					// Start transition to hide the view element
					emailView.classList.add('opacity-0');
					emailView.classList.add('pointer-events-none');

					// Ensure the email element is ready to be shown
					setTimeout(() => {
						email.classList.remove('hidden');
						// Fully display the email element after the transition
						emailView.classList.add('hidden');
						email.classList.remove('opacity-0');
					}, 300); // Match this duration with your transition duration
				}
			});
			emailDetail.dataset.hasListener = 'true';
		}
	}

	function removeFormFieldFocus() {
		const enquiryContactFormContainer = document.querySelectorAll<HTMLElement>('.enquiry-contact-form-container');
		for (const formContainer of enquiryContactFormContainer) {
			const formFields = formContainer.querySelectorAll<HTMLInputElement>('input, textarea');
			for (const formField of formFields) {
				formField.blur();
			}
		}
	}

	const destroyEnquireContact = () => {
		// Destory each Glide instance to prevent memory leaks

		for (const [element, event, listener] of listeners) {
			element.removeEventListener(event, listener);
		}
	};

	return { destroyEnquireContact };
}
